/**
 * R.H.I.E. Confetti Component
 * Minimal, elegant konfeti efekti
 */

import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const CONFETTI_COLORS = [
  '#7C3AED', // Purple
  '#FFA94D', // Amber
  '#2DE2E6', // Cyan
  '#B19CFF', // Violet
  '#34D399', // Emerald
  '#F472B6', // Pink
];

const generateParticles = (count = 50) => {
  return Array.from({ length: count }, (_, i) => ({
    id: i,
    x: Math.random() * 100,
    color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
    delay: Math.random() * 0.5,
    duration: 2 + Math.random() * 2,
    size: 4 + Math.random() * 8,
    rotation: Math.random() * 360,
    isCircle: Math.random() > 0.5
  }));
};

export default function RHIEConfetti() {
  const [particles] = useState(() => generateParticles(40));
  
  return (
    <div className="fixed inset-0 pointer-events-none z-[200] overflow-hidden">
      {particles.map((particle) => (
        <motion.div
          key={particle.id}
          initial={{
            opacity: 1,
            x: `${particle.x}vw`,
            y: -20,
            rotate: 0,
            scale: 1
          }}
          animate={{
            opacity: [1, 1, 0],
            y: '110vh',
            rotate: particle.rotation + 720,
            scale: [1, 1.2, 0.8]
          }}
          transition={{
            duration: particle.duration,
            delay: particle.delay,
            ease: 'easeOut'
          }}
          style={{
            position: 'absolute',
            width: particle.size,
            height: particle.size,
            backgroundColor: particle.color,
            borderRadius: particle.isCircle ? '50%' : '2px',
            boxShadow: `0 0 ${particle.size}px ${particle.color}50`
          }}
        />
      ))}
      
      {/* Center burst effect */}
      <motion.div
        initial={{ opacity: 0.8, scale: 0 }}
        animate={{ opacity: 0, scale: 3 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full"
        style={{
          background: 'radial-gradient(circle, rgba(124, 58, 237, 0.3), transparent)'
        }}
      />
    </div>
  );
}
